import { ThemeProvider, CssBaseline } from '@mui/material';
import { almaStyleArticleTheme } from '../../../ArticleTheme';
import FootnotesList from '../../../components/Article/FootnotesList';
import { getArticleElement } from '../utils/renderingUtils';
import Article from '../../../types/Article';

interface ArticleFullViewProps {
  article: Article;
}

export default function ArticleFullView({
  article,
}: Readonly<ArticleFullViewProps>) {
  return (
    <ThemeProvider theme={almaStyleArticleTheme}>
      <CssBaseline>
        {article?.content?.articleElements.map((child) =>
          getArticleElement(child, article),
        )}
        <FootnotesList footnotes={article.content.footnotes} />
      </CssBaseline>
    </ThemeProvider>
  );
}
